
<div class="graph-container">
  <app-percentage-of-new-patients-multilevel-chart
    [isSpecialty]="false"
    [isDepartment]="false"
    [level]="'By Provider'"
    [chosenTab]="MultilevelTab.BY_PROVIDER"
    [barSelectionCallback]="whenBarSelected"
    [npvData]="newPatientVisits"
    [zeroSuppression]="zeroSuppression"
    [benchmarkPercentile]="benchmarkPercentile"
    [benchmarkOption]="benchmarkOption"
    [activeVarianceToggle]="activeVarianceToggle"
    [showProgressBar]="showProgressBar"
    page="npvSnapshot"
    [showVariableMenu]="true"
    [tieBreakerProperty]="tieBreakerProperty"
    [sortingCriteria]="npvSortingCriteria"
    [varianceKey]="varianceKey"
    [variables]="variables">
  </app-percentage-of-new-patients-multilevel-chart>
</div>
<app-new-patient-visits-summary-data-table></app-new-patient-visits-summary-data-table>
<app-new-patient-visits-data-table id="npv-snapshot"
                [receivedData]="newPatientVisits"
                [updateSortingCriteria]="updateSortingCriteria"
                [columns]="displayedColumns"
                [whenSortChanged]="levelSpecificHandleSortChange"
                [defaultSortColumn]="defaultSortColumn"
                [sortDirection]="sortDirection"
                [sortingDataAccessor]="sortingDataAccessor"
                [tieBreakerProperty]="tieBreakerProperty"
                [rowSelectionCallback]="whenProviderSelected"
                [tableTitle]="'New Patients By Provider'"
                [showLevel]="false"
                [showProgressBar]="showProgressBar"
                [displayZeroSuppression]=true
                [shouldPutNullsAtTheBottom]="activeVarianceToggle"
                [isZeroSuppressionChecked]="zeroSuppression"
                [countOfSuppressedEntries]="countOfSuppressedEntries"
                [zeroSuppressionCondition]="zeroSuppressionCondition"
                [currentPage]="currentPage"
                [originalColumns]="columns"
                [addRemoveOption]="true"
                [reducerAction]="snapshotNPVColumnsChangedTo" zeroSuppressionSnapshotEntry = "Providers"
>
</app-new-patient-visits-data-table>
